import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { StabilizedBridgeStore } from '../stores';

export const useStabilizedBridgeStore = () => useContext<{
  stabilizedBridgeStore: StabilizedBridgeStore
}>(StoreContext);
